import { render, staticRenderFns } from "./ProfileHeaderButton.vue?vue&type=template&id=196e261b&scoped=true&"
import script from "./ProfileHeaderButton.vue?vue&type=script&lang=js&"
export * from "./ProfileHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e261b",
  null
  
)

export default component.exports